<template>
  <div class="container-fluid">
    <div v-if="isRedirectToSubscribe" class="d-flex justify-content-center pt-5">
      <label>
        <h4 class="text-center">{{ seconds }}</h4>
        {{ $t('object.monitoring.need-subscribe-msg') }}
      </label>
    </div>

    <div v-else class="card border-primary shadow-lg">
      <div class="card-header text-white bg-primary mb-2">
        <label>{{ $t('object.monitoring.title') }}</label>
      </div>

      <div class="card-body">
        <TableField
            v-model:params="params"
            :data="objects"
            :columns="columns"
            :loading="loading"
            showSearch
            stickyHeader
            columnChooser
            mobileDevices
            storeSearch
            section="objectMonitoring"
            @fetch-data="populateData"
            @action="handleAction"
        >
          <template #cell-status="{ value, row }">
            <button
                v-if="row.billObjectId == null && isCanBuy"
                type="button" class="btn btn-success btn-sm"
                @click="getBuyObject(row.objectId)"
            >
              {{ $t('object.monitoring.first_activation') }}
            </button>
            <button
                v-else-if="row.billObjectId == null"
                type="button" class="btn btn-success btn-sm"
                @click="storeObjectToBilling(row.objectId)"
            >
              {{ $t('object.monitoring.first_activation') }}
            </button>
            <button
                v-else-if="value == 1"
                type="button" class="btn btn-primary btn-sm"
                @click="addComment(row)"
            >
              {{ $t('object.monitoring.active') }}
            </button>
            <button
                v-else type="button"
                class="btn btn-warning btn-sm"
                @click="addComment(row)"
            >
              {{ $t('object.monitoring.disabled') }}
            </button>
          </template>

          <template #cell-nextBillDate="{ value, row }">
            <template v-if="value === '0' && isThisMonth(row.nextBillDate)">
              {{ formatDate(value) }}
            </template>
          </template>
        </TableField>
      </div>
    </div>

    <message :message="message" :link="isMsg" :isVisible=isVisibleMsg @onVisible="changeIsVisibleMsg" />
  </div>

  <ActionComment ref="showActionComment" @confirm="addComment($event, 1)" />
  <ShowObjectInfo ref="showObjectInfo" @onChangeObject="changeObject" />
  <ShowObjectComment ref="showObjectComment" />
</template>

<script src="./ObjectMonitoring.js"></script>
